import React from "react";
import UserProfileTable from "src/pages/user-profile";

export default function UserProfilePage() {
  return <UserProfileTable />;
}
